import { useQuery } from '@apollo/client';
import { z } from 'zod';

import { useDebounceWithStatus } from '../useDebounceWithStatus';
import { TeamMembersEmailExistsDocument } from './teamMemberEmailsExists.gql';

const emailSchema = z.string().email();

export const useTeamMemberEmailExists = ({
  companyProfileId = '',
  email = '',
}: {
  companyProfileId?: string;
  email?: string;
}) => {
  const emailValid = emailSchema.safeParse(email).success;
  const enabled = emailValid && Boolean(companyProfileId);

  const { debouncing, value: debouncedEmail } = useDebounceWithStatus(email);

  const { data, loading, ...hook } = useQuery(TeamMembersEmailExistsDocument, {
    notifyOnNetworkStatusChange: true,
    skip: !enabled,
    variables: { companyProfileId, email: debouncedEmail },
  });

  const emailExists = (data?.viewer.company.teamMembers.edges?.length ?? 0) > 0;
  const firstTeamMember = data?.viewer.company.teamMembers.edges?.[0]?.node;

  return {
    ...hook,
    emailExists,
    firstTeamMember,
    loading: (emailValid && debouncing) || loading,
  };
};
